var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDsvgoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.965.103a1.865 1.865 0 0 0-1.862 1.862v28.133c0 1.027.835 1.862 1.862 1.862h20.35a1.864 1.864 0 0 0 1.86-1.862V22.11c-.087-.453 0-16.111 0-16.111a.62.62 0 0 0-.18-.439L22.718.285a.62.62 0 0 0-.44-.182zm.207 2.07h15.087v4.201c0 .425.344.77.768.77h4.08v4.76q.002 8.994.001 17.987H6.172z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.062 5.136h5.916a.759.759 0 0 0 0-1.517H9.062a.758.758 0 1 0 0 1.517m11.256 2.17a.76.76 0 0 0-.759-.758H9.092a.759.759 0 0 0 0 1.517h10.467c.42 0 .759-.34.759-.759M9.08 11.1h5.916a.758.758 0 1 0 0-1.517H9.08a.759.759 0 0 0 0 1.517m12.669 7.592h-.809v-1.998a4.562 4.562 0 0 0-9.123 0v1.998h-.81a.47.47 0 0 0-.469.47v8.852a.47.47 0 0 0 .47.473h10.74a.47.47 0 0 0 .471-.473v-8.851a.47.47 0 0 0-.47-.47m-4.635 5.385v1.886a.29.29 0 0 1-.292.292h-.876a.29.29 0 0 1-.292-.292v-1.886a1.274 1.274 0 1 1 1.46 0m1.648-5.386h-4.767v-1.998a2.383 2.383 0 1 1 4.767 0z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsvgoIcon);
export default __webpack_public_path__ + "static/media/DSVGO_icon.07eb34a7e9a308393a5bf7a84e7c2655.svg";
export { ForwardRef as ReactComponent };